/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BedType
 */
export interface BedType {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the BedType interface.
 */
export function instanceOfBedType(value: object): value is BedType {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function BedTypeFromJSON(json: any): BedType {
    return BedTypeFromJSONTyped(json, false);
}

export function BedTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
    };
}

export function BedTypeToJSON(json: any): BedType {
    return BedTypeToJSONTyped(json, false);
}

export function BedTypeToJSONTyped(value?: BedType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

